import React from 'react'
import * as S from './styles'
import { HorizontalActionMenuProps } from '../../types'
import { ReactComponent as PendencyIcon } from 'presentation/assets/icons/pendency-icon.svg'
import { ReactComponent as TimelineIcon } from 'presentation/assets/icons/timeline-icon.svg'
import { ReactComponent as ElegibilityIcon } from 'presentation/assets/icons/eligibility-icon.svg'
import { ReactComponent as AuthorizationIcon } from 'presentation/assets/icons/article-shortcut-icon.svg'
import { ReactComponent as RedoIcon } from 'presentation/assets/icons/redo-icon.svg'
import { ReactComponent as FinishOrderIcon } from 'presentation/assets/icons/finish-order-icon.svg'
import { ReactComponent as OverviewIcon } from 'presentation/assets/icons/overview-icon.svg'
import { ReactComponent as GenerateGuidesIcon } from 'presentation/assets/icons/add-notes-icon.svg'

export const HorizontalActionMenu = ({
  activeItem,
  onItemClick,
  handleOpenRemakeModal,
  handleOpenGuidesModal,
  handleOpenFinishOrderEdit,
  handleOpenActiveOrderReview
}: HorizontalActionMenuProps) => {
  return (
    <S.MenuWrapper>
      <S.MenuItem
        onClick={() => onItemClick('pendencias')}
        selected={activeItem === 'pendencias'}
      >
        <S.IconWrapper selected={activeItem === 'pendencias'}>
          <PendencyIcon />
        </S.IconWrapper>
        <span>Pendências</span>
      </S.MenuItem>

      <S.MenuItem
        onClick={() => onItemClick('linha-tempo')}
        selected={activeItem === 'linha-tempo'}
      >
        <S.IconWrapper selected={activeItem === 'linha-tempo'}>
          <TimelineIcon />
        </S.IconWrapper>
        <span>Linha do Tempo</span>
      </S.MenuItem>

      <S.MenuItem
        onClick={() => onItemClick('elegibilidade')}
        selected={activeItem === 'elegibilidade'}
      >
        <S.IconWrapper selected={activeItem === 'elegibilidade'}>
          <ElegibilityIcon />
        </S.IconWrapper>
        <span>Elegibilidade</span>
      </S.MenuItem>

      <S.MenuItem
        onClick={() => onItemClick('autorizacao')}
        selected={activeItem === 'autorizacao'}
      >
        <S.IconWrapper selected={activeItem === 'autorizacao'}>
          <AuthorizationIcon />
        </S.IconWrapper>
        <span>Acompanhar Autorização</span>
      </S.MenuItem>

      <S.MenuItem onClick={handleOpenRemakeModal} selected={false}>
        <S.IconWrapper selected={false}>
          <RedoIcon />
        </S.IconWrapper>
        <span>Refazer Pedido</span>
      </S.MenuItem>

      <S.MenuItem onClick={handleOpenFinishOrderEdit} selected={false}>
        <S.IconWrapper selected={false}>
          <FinishOrderIcon />
        </S.IconWrapper>
        <span>Finalizar Pedido</span>
      </S.MenuItem>

      <S.MenuItem onClick={handleOpenActiveOrderReview} selected={false}>
        <S.IconWrapper selected={false}>
          <OverviewIcon />
        </S.IconWrapper>
        <span>Resumo do Pedido</span>
      </S.MenuItem>

      <S.MenuItem onClick={handleOpenGuidesModal} selected={false}>
        <S.IconWrapper selected={false}>
          <GenerateGuidesIcon />
        </S.IconWrapper>
        <span>Gerar Guias</span>
      </S.MenuItem>
    </S.MenuWrapper>
  )
}
